'use client';

import { Toaster as Sonner } from 'sonner';
import type { ToasterProps } from 'sonner';
import { Icon } from '@/components/ui/icon';
import { Spinner } from '@/components/ui/spinner';

/**
 * Toasts restylés Arti Pilotage (design/components/feedback/Toast.jsx) :
 * fonds sémantiques pleins (encre/succès/alerte/danger/info), texte clair,
 * rayon 16, ombre profonde, icônes maison. sonner gère la pile, l'auto-
 * dismiss et les rôles aria (status/alert selon la tonalité).
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      position="top-right"
      icons={{
        success: <Icon name="valider" size={14} accent="currentColor" />,
        info: <Icon name="notif" size={14} accent="currentColor" />,
        warning: <Icon name="alerte" size={14} accent="currentColor" />,
        error: <Icon name="alerte" size={14} accent="currentColor" />,
        loading: <Spinner className="size-3.5" />,
      }}
      style={
        {
          // Toast neutre = encre, texte sable (constant en clair et sombre)
          '--normal-bg': '#2b2723',
          '--normal-text': '#f4f0e8',
          '--normal-border': 'transparent',
          '--border-radius': '16px',
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast:
            '!font-sans !rounded-sm !border-none !shadow-e3',
          title: '!text-sm !font-bold',
          // `text-current` : sonner colore la description par sa propre
          // variable, qui restait sombre sur nos fonds pleins — gris sur
          // vert. Elle doit hériter de l'encre du toast.
          description: '!text-sm !text-current !opacity-90',
          success: '!bg-success !text-white',
          warning: '!bg-warning !text-white',
          error: '!bg-danger !text-white',
          info: '!bg-info !text-white',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
